const ContentTypes = {
  file: 'file',
  comment: 'comment',
};

export default ContentTypes;
